/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface DownloadReport$Request {
    accountId: number;
}

export interface DownloadReport$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const downloadReportRequest = createAction<PayloadData<void, DownloadReport$Request>>('CREDIT_HISTORY_REPORT_CONTROLLER__DOWNLOAD_REPORT__REQUEST');
export const downloadReportSuccess = createAction<PayloadData<any, DownloadReport$Request>>('CREDIT_HISTORY_REPORT_CONTROLLER__DOWNLOAD_REPORT__SUCCESS');
export const downloadReportFailure = createAction<PayloadData<Error, DownloadReport$Request, true>>('CREDIT_HISTORY_REPORT_CONTROLLER__DOWNLOAD_REPORT__FAILURE');

export const downloadReportActions = [
    downloadReportRequest,
    downloadReportSuccess,
    downloadReportFailure
] as const;

/**
 * Download credit report history
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const downloadReport = (meta: DownloadReport$Request, config?: DownloadReport$Config) => {
    return {
        DOWNLOAD_FILE: {
            types: downloadReportActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/api-v2/${meta.accountId}/credits-history-report`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/octet-stream, application/json',
            }
        },
        ...meta
    }
};

